import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import { QueryProvider } from "./providers/QueryProvider.tsx";
import { ErrorBoundary } from "./components/ErrorBoundary.tsx";
import { Toaster } from 'sonner';
import { bootstrapI18n } from "./i18n/bootstrap";

import { TempoDevtools } from "tempo-devtools";
TempoDevtools.init();

// Enable detailed logging in development
if (process.env.NODE_ENV === 'development') {
  console.log('🚀 Development mode enabled');
  console.log('📍 Current URL:', window.location.href);
  
  // Log all unhandled errors
  window.addEventListener('error', (event) => {
    console.error('❌ Unhandled Error:', event.error);
    console.error('📄 Stack:', event.error?.stack);
    console.error('📍 File:', event.filename, 'Line:', event.lineno);
  });

  // Log all unhandled promise rejections
  window.addEventListener('unhandledrejection', (event) => {
    console.error('❌ Unhandled Promise Rejection:', event.reason);
  });
}

const basename = import.meta.env.BASE_URL;

// Sprache VOR dem ersten Render herstellen. Deutsch ist statisch gebündelt →
// löst sofort auf (kein Flash). `finally`: ein i18n-Fehler darf die App nie blockieren.
bootstrapI18n().finally(() => {
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <ErrorBoundary>
        <QueryProvider>
          <BrowserRouter basename={basename}>
            <App />
            <Toaster
              position="top-right"
              richColors
              closeButton
              toastOptions={{
                duration: 4000,
              }}
            />
          </BrowserRouter>
        </QueryProvider>
      </ErrorBoundary>
    </React.StrictMode>,
  );
});
